import { takeLatest, put, all, call } from 'redux-saga/effects';
import DataActionType from './data.types';
import { dataLoadSuccess, dataLoadFailure } from './data.action';
import { httpTismsApi } from '../../api/httpTismsApi';
import type { Bootstrap } from '../../api/httpTismsApi';
import type { Dccb, Branch } from '../../data/tisms-api';
import { toApiError } from '../_common/apiClient';

/* Fetch the reference/bootstrap payload plus the DCCB + branch lists in
   parallel, then populate the data slice. */
function* dataLoadAsync(): Generator {
  try {
    const [bootstrap, dccbs, branches] = (yield all([
      call(httpTismsApi.getBootstrap),
      call(httpTismsApi.getDccbs),
      call(httpTismsApi.getBranches),
    ])) as [Bootstrap, Dccb[], Branch[]];
    yield put(dataLoadSuccess({ bootstrap, dccbs, branches }));
  } catch (error) {
    yield put(dataLoadFailure(toApiError(error).message));
  }
}

export function* onDataLoadStart(): Generator {
  yield takeLatest(DataActionType.DATA_LOAD_START, dataLoadAsync);
}

export function* dataSaga(): Generator {
  yield all([call(onDataLoadStart)]);
}
